import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SpecraBadge, SpecraButton, SpecraLink } from '@mono/ui-components/ensigns';
import { SpecraPageHeader } from '@mono/ui-components/lieutenants';
import { Testids } from '@mono/ui-selectors';
import { renderRouterLink } from '../../../../lib/renderRouterLink';
import { vehicleTypeLabel } from '../../../Delivery/Registries/contractVehicleUi';
import { registryHref } from '../../registryHref';
import { HoldingBadge, monthYear, orderingEligibilityLabel, VehicleRefLink } from './vehicleUi';
export function VehicleHeader({ dossier: d, onUpload, extraActions }) {
    const successor = d.successors.find((edge)=>edge.relation === 'SUCCESSOR' && !edge.archivedAt)?.successor;
    const successorHref = successor?.id ? registryHref(successor) : null;
    const eligibility = orderingEligibilityLabel(d.orderingEligibility);
    const description = [
        d.fullName,
        eligibility
    ].filter(Boolean);
    return /*#__PURE__*/ _jsx(SpecraPageHeader, {
        titleSize: "home",
        title: d.name,
        eyebrow: `Contract vehicle · ${vehicleTypeLabel(d.vehicleType)}`,
        description: (description.length > 0 || d.awardingOrg) && /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                description.join(' · '),
                d.awardingOrg && /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        description.length > 0 && ' · ',
                        "awarded by ",
                        /*#__PURE__*/ _jsx(VehicleRefLink, {
                            value: d.awardingOrg
                        })
                    ]
                })
            ]
        }),
        meta: /*#__PURE__*/ _jsxs("div", {
            className: "flex flex-wrap gap-2",
            children: [
                d.ourStatus?.kind && d.ourStatus.kind !== 'NOT_ON_IT' && /*#__PURE__*/ _jsxs(SpecraBadge, {
                    variant: "outline",
                    children: [
                        /*#__PURE__*/ _jsx(HoldingBadge, {
                            status: d.ourStatus.kind
                        }),
                        ' ',
                        d.ourStatus.kind === 'HOLDER' ? "we're on it as a prime" : /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                "through ",
                                /*#__PURE__*/ _jsx(VehicleRefLink, {
                                    value: d.ourStatus.viaCompany
                                })
                            ]
                        })
                    ]
                }),
                d.orderingEnd && /*#__PURE__*/ _jsxs(SpecraBadge, {
                    variant: "outline",
                    children: [
                        "Ordering ends ",
                        monthYear(d.orderingEnd)
                    ]
                }),
                successor && /*#__PURE__*/ _jsx(SpecraBadge, {
                    variant: "outline",
                    "data-testid": Testids.registryVehicle.successorChip,
                    children: /*#__PURE__*/ _jsx(SpecraLink, {
                        href: successorHref ?? '#successor',
                        renderLink: successorHref ? renderRouterLink : undefined,
                        children: `Successor: ${successor.name} →`
                    })
                }),
                /*#__PURE__*/ _jsx(SpecraBadge, {
                    variant: "outline",
                    children: d.holderCount === 1 ? '1 holder' : `${d.holderCount} holders`
                })
            ]
        }),
        actions: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                onUpload && /*#__PURE__*/ _jsx(SpecraButton, {
                    variant: "secondary",
                    onClick: onUpload,
                    children: "Upload pricing sheet"
                }),
                extraActions
            ]
        })
    });
}
